// This is temporary until all users are migrated to the new permission entry.
const getIsOwner = ({permission} = {}) => (typeof permission === 'object' ? permission.permission : permission) === 'owner';

export default getIsOwner;
